import IconComponent from 'gcs-common/components/Icon/Icon';
import { ICON, ICON_COLOR, ICON_SIZE } from 'gcs-common/constants/IconConstants';
import { getSelectedChannelId } from 'gcs-common/slices/channels/channelsSelectors';
import {
  getMessageDateCreated,
  getMessageIsFavorite,
  getMessageIsFromMe,
  getMessageShouldShowOptionsMenu,
} from 'gcs-common/slices/messages/messageSelector';
import PropTypes from 'prop-types';
import { useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import LinkPreview from '../../LinkPreview/LinkPreview';
import MessageName from '../MessageName/MessageName';
import MessageOptionsMenu from '../MessageOptionsMenu/MessageOptionsMenu';
import styles from './styles.module.scss';

const BaseMessage = ({ messageId, children }) => {
  const isFromMe = useSelector(getMessageIsFromMe(messageId));
  const isFavorite = useSelector(getMessageIsFavorite(messageId));
  const dateCreated = useSelector(getMessageDateCreated(messageId));
  const selectedChannelId = useSelector(getSelectedChannelId);
  const shouldShowOptionsMenu = useSelector(getMessageShouldShowOptionsMenu(selectedChannelId, messageId));

  const [showOptionMenuButton, setShowOptionMenuButton] = useState(false);

  const rootDomNode = useRef();

  const formattedTimestamp = useMemo(() => dateCreated?.format('LT'), [dateCreated]);

  return (
    <div
      className={`${styles.msg} ${isFromMe ? styles.me : ''}`}
      ref={rootDomNode}
      onMouseEnter={() => setShowOptionMenuButton(true)}
      onMouseLeave={() => setShowOptionMenuButton(false)}
      role="group"
    >
      <div className={styles.msgContent}>
        <div className={styles.msgHeader}>
          {!isFromMe && <MessageName channelId={selectedChannelId} messageId={messageId} />}
          {shouldShowOptionsMenu && (
            <MessageOptionsMenu showIcon={showOptionMenuButton} messageId={messageId} parent={rootDomNode} />
          )}
        </div>
        {children}
        <LinkPreview messageId={messageId} />
        <div className={styles.msgFooter}>
          {isFavorite && (
            <IconComponent
              Icon={ICON.STAR_FILLED}
              color={ICON_COLOR.PRIMARY}
              size={ICON_SIZE.SMALL}
              style={{ marginLeft: '-4px' }}
              alt="Favorit"
            />
          )}
          <span className={styles.timeStamp}>{formattedTimestamp}</span>
        </div>
      </div>
    </div>
  );
};

BaseMessage.propTypes = {
  messageId: PropTypes.string.isRequired,
  children: PropTypes.element.isRequired,
};

export default BaseMessage;
